import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import SubCategoryDetails from '../../components/Pages/SubCategory';

const { displayName } = config;

export default function SubCategory(): React.ReactNode | null {
  document.title = `${displayName}: SubCategory details`;

  return (
    <Layout>
      <SubCategoryDetails />
    </Layout>
  );
}
